import { render, staticRenderFns } from "./NewslettersGroupUsers.vue?vue&type=template&id=90dbb0fe"
import script from "./NewslettersGroupUsers.vue?vue&type=script&lang=js"
export * from "./NewslettersGroupUsers.vue?vue&type=script&lang=js"
import style0 from "./NewslettersGroupUsers.vue?vue&type=style&index=0&id=90dbb0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports